@if (canPrint()) {
  <!-- transcluded header -->
  <div class="w-12 flex flex-bottom flex-wrap-s flex-wrap-m wrap">
    <div class="c-11 m-b-0">
      <ng-content></ng-content>
    </div>
    <!-- navigation -->
    <div class="w-1 w-12-m w-12-s right">
      @if (localListing.models?.length > [1.3,2.3,3.5,4.4][client.sizeId]) {
        <button class="m-r-3"
          [ngClass]="'product-prev-' + getEnginesName()"
          aria-label="Previous slide"
          >
          <i class="icon-chevron-left"
          aria-hidden="true"></i>
        </button>
      }
      @if (localListing.models?.length > [1.3,2.3,3.5,4.4][client.sizeId]) {
        <button [ngClass]="'product-next-' + getEnginesName()"
          aria-label="Next slide"
          >
          <i class="icon-chevron-right"
          aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>
  <div class="wrap overflow-hidden related-products-carousel">
    <!-- slider -->
    <carousel [slidesPerView]="[1.3,2.3,3.5,4.4][client.sizeId]"
      [spaceBetween]="20"
                  [navigation]="{
                    nextEl: '.product-next-' + getEnginesName(),
                    prevEl: '.product-prev-' + getEnginesName()
                }"
      [freeMode]="true"
      [scrollbar]="{ draggable: true }"
      class="m-t-10 p-b"
      imageViewRoot>
      @for (model of localListing.models; track model; let index = $index) {
        <ng-template swiperSlide
          >
          <product [model]="model"></product>
        </ng-template>
      }
    </carousel>
  </div>
}
